export enum CorporateAdminStatus {
  Active = 0,
  Inactive = 1,
  Terminated = 2,
  Suspended = 3,
  PendingSetup = 4,
}
